import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ComponentFactoryResolver,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GfxMiscSrv } from "src/app/services/gfx.misc.service";
import { GfxStoreService } from "src/app/services/gfx.store.service";
import { GfxModalHostComponent } from "../gfx-modal-host/gfx-modal-host.component";
import { ModalConfig } from "./modal-config";
import { SharingDataService } from "src/app/services/sharing-data.service";
@Component({
  selector: "gfx-modal",
  templateUrl: "./gfx-modal.component.html",
  styleUrls: ["./gfx-modal.component.css"],
})
export class GfxModalComponent implements OnInit {
  @Input("modalConfig") modalConfig: ModalConfig;

  constructor(
    public modalService: NgbModal,
    private sharing: SharingDataService
  ) {}

  ngOnInit() {
    this.sharing.changeModalConfig(this.modalConfig);

    const modalRef = this.modalService.open(
      GfxModalHostComponent,
      this.modalConfig.options
    );
    setTimeout(function () {}, 430);
  }
}
